var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"move-events"},[_c('SimpleAppTable',{staticClass:"move-events__table",attrs:{"data-props":_vm.tableProps,"table-list":_vm.tableList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }